import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreBoolean, restoreNumber } from '../../ParseHelper';
import { AudioStreamType } from '../../../System/Audio/AudioSystem';
import { MUSIC_VOLUME_VALUE, SOUND_VOLUME_VALUE } from 'Constants/World';

type PlayerStateKey = 'settings';
type PlayerDataKeys = AudioStreamType | 'cinematicMode';
export default class Settings implements PlayerProperty<PlayerStateKey, PlayerDataKeys> {
    public isChanged(playerStateData: IPlayerState, playerEndpointData: IPlayerData): boolean {
        const restoredEndpointData = this.restore(playerEndpointData);
        return (
            restoredEndpointData[AudioStreamType.MUSIC] !== playerStateData.settings[AudioStreamType.MUSIC] ||
            restoredEndpointData[AudioStreamType.SFX] !== playerStateData.settings[AudioStreamType.SFX] ||
            restoredEndpointData.cinematicMode !== playerStateData.settings.cinematicMode
        );
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        return {
            [AudioStreamType.MUSIC]: restoreNumber(playerEndpointData[AudioStreamType.MUSIC], MUSIC_VOLUME_VALUE),
            [AudioStreamType.SFX]: restoreNumber(playerEndpointData[AudioStreamType.SFX], SOUND_VOLUME_VALUE),
            cinematicMode: restoreBoolean(playerEndpointData.cinematicMode, false),
        };
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            [AudioStreamType.MUSIC]: playerStateData.settings[AudioStreamType.MUSIC],
            [AudioStreamType.SFX]: playerStateData.settings[AudioStreamType.SFX],
            cinematicMode: Number(playerStateData.settings.cinematicMode),
        };
    }
}
